<template>
  <div class="inst_wrapper">

     
      <img :src="component_data.params.img.src" alt="" class="inst_image">
      <div class="inst_links">
          <h2 v-html="component_data.params.title"></h2>
                      <video-block
          class="feat_instruction_video"
          v-if="component_data.params.vid"
          :component_data="component_data.params.vid"
        >     <p class="inst_link video_link"><b>Obejrzyj film</b></p></video-block>
          <a :href="component_data.params.link1" class="inst_link"><b>Pobierz</b> (iOS)</a>
          <a :href="component_data.params.link2" class="inst_link"><b>Pobierz</b> (Android)</a>
     
      </div>
        
  </div>
</template>

<script>
import video from "@/components/videoBlock/video_bodyless";
export default {
  props: ["component_data"],
  components: {
    "video-block": video,
  },
};
</script>

<style scoped>
.inst_wrapper {
  position: relative;
  width: 83.33%;
  margin: 0 auto;
  border-top: solid 2px #707070;
  padding: 50px 0;
  display: flex;
}
.inst_image {
  width: 50%;
  object-fit: contain;
}
.feat_instruction_video {
}
.inst_links {
  width: 30%;
  padding: 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.inst_links h2 {
  margin-bottom: 1em;
}
.inst_link {
  font-family: "Uni Neue", sans-serif;
  text-decoration: none;
  letter-spacing: 0.6px;
  color: #27241d;
  display: block;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='23' viewBox='0 0 21 23'%3E%3Cpath d='M18.154,11.833h-.7V6.053L12.036,0H2.624A2.628,2.628,0,0,0,0,2.625V19.375A2.627,2.627,0,0,0,2.624,22h12.2a2.627,2.627,0,0,0,2.624-2.625v-.366h.7A1.849,1.849,0,0,0,20,17.161v-3.48A1.849,1.849,0,0,0,18.154,11.833ZM12.233,1.285,16.3,5.835H12.233Zm4.506,18.089a1.916,1.916,0,0,1-1.914,1.915H2.624A1.916,1.916,0,0,1,.71,19.375V2.625A1.916,1.916,0,0,1,2.624.71h8.9V6.545h5.218v5.288H8.958a1.849,1.849,0,0,0-1.846,1.847v3.482A1.849,1.849,0,0,0,8.958,19.01h7.782v.365Zm2.551-2.212A1.138,1.138,0,0,1,18.154,18.3h-9.2a1.138,1.138,0,0,1-1.136-1.137V13.681a1.138,1.138,0,0,1,1.136-1.137h9.2a1.138,1.138,0,0,1,1.136,1.137Z' /%3E%3C/svg%3E"),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7.247' height='7.2' viewBox='0 0 7.247 7.2'%3E%3Cg transform='translate(7.114 -1.414) rotate(90)'%3E%3Cpath class='a' d='M4.4,3.14.822.082A.553.553,0,0,0,.1.082.381.381,0,0,0,.1.695L3.328,3.45.1,6.2a.381.381,0,0,0,0,.613.553.553,0,0,0,.717,0L4.4,3.756a.387.387,0,0,0,0-.616Z' transform='translate(1.564 0.042)' /%3E%3Cg transform='translate(7.556 -0.008)'%3E%3Cpath class='a' d='M171.079,8.2a.448.448,0,0,1-.479-.414V1.614a.484.484,0,0,1,.959,0V7.786A.45.45,0,0,1,171.079,8.2Z' transform='translate(-170.6 -1.2)' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

  background-repeat: no-repeat;
  background-position: left center, right center;
  padding: 0.8em 3em;

  border-bottom: solid 1px #707070;
}
.inst_link.video_link {
  background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220.5%22%20height%3D%2220.5%22%20viewBox%3D%220%200%2020.5%2020.5%22%3E%3Cpath%20d%3D%22M0%2C10.25A10.25%2C10.25%2C0%2C1%2C1%2C10.25%2C20.5%2C10.262%2C10.262%2C0%2C0%2C1%2C0%2C10.25Zm1.577%2C0A8.673%2C8.673%2C0%2C1%2C0%2C10.25%2C1.577%2C8.683%2C8.683%2C0%2C0%2C0%2C1.577%2C10.25Zm7.125%2C4.3a.815.815%2C0%2C0%2C1-.206-.691.345.345%2C0%2C0%2C1-.011-.088V6.731a.373.373%2C0%2C0%2C1%2C.008-.073.824.824%2C0%2C0%2C1%2C.136-.483%2C1.074%2C1.074%2C0%2C0%2C0-.111.1L8.7%2C6.086a.612.612%2C0%2C0%2C0-.074.09A1.05%2C1.05%2C0%2C0%2C1%2C10%2C6.264l3.523%2C3.484a.735.735%2C0%2C0%2C1%2C.006%2C1.041L9.817%2C14.542a.837.837%2C0%2C0%2C1-1.116.006Zm1.359-2.493%2C1.761-1.777L10.06%2C8.537Z%22%2F%3E%3C%2Fsvg%3E"),
    url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%224.803%22%20height%3D%227.247%22%20viewBox%3D%220%200%204.803%207.247%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bstroke%3A%23000%3Bstroke-linecap%3Around%3Bstroke-width%3A0.2px%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20transform%3D%22translate%28-3.392%200.133%29%22%3E%3Cpath%20class%3D%22a%22%20d%3D%22M4.4%2C3.14.822.082A.553.553%2C0%2C0%2C0%2C.1.082.381.381%2C0%2C0%2C0%2C.1.695L3.328%2C3.45.1%2C6.2a.381.381%2C0%2C0%2C0%2C0%2C.613.553.553%2C0%2C0%2C0%2C.717%2C0L4.4%2C3.756a.387.387%2C0%2C0%2C0%2C0-.616Z%22%20transform%3D%22translate%283.542%200.042%29%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%0A");
}
.inst_link:nth-of-type(2) {
  border-bottom: none;
}
.inst_link:hover {
  color: crimson;
}
@media (max-width: 1600px) {
  .inst_links {
    width: 50%;
  }
}
@media (max-width: 960px) {
  .inst_wrapper {
    flex-direction: column;
  }
  .inst_image,
  .inst_links {
    width: 100%;
  }
}
</style>
